<template>
  <div v-if="page > 1" class="xl-pagination">
    <span class="pag-btn" :class="prevClass" @click="goPrev">上一页</span>
    <span
      v-for="(key, i) in list"
      :key="i"
      :class="getCurClass(key, i)"
      @click="goIndex(key)"
    >
      {{ key }}
    </span>
    <span class="pag-btn" :class="nextClass" @click="goNext">下一页</span>
  </div>
</template>

<script>
export default {
  name: 'XlPagination',
  props: {
    page: {
      type: Number,
      default: 0,
      require: true,
      validator(val) {
        return val >= 0
      }
    },
    index: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      cur: this.index
    }
  },
  computed: {
    prevClass() {
      return {
        disabled: this.cur < 2
      }
    },
    nextClass() {
      return {
        disabled: this.cur > this.page - 1
      }
    },
    list() {
      if (this.page < 10) {
        let page = this.page
        const list = []
        while (page) {
          list.unshift(page--)
        }
        return list
      } else {
        if (this.cur < 4) {
          return [1, 2, 3, 4, 5, '...', this.page]
        }
        if (this.cur === 4) {
          return [1, 2, 3, 4, 5, 6, '...', this.page]
        }
        if (this.page - this.cur < 4) {
          const list = []
          let page = 6
          while (page) {
            list.push(this.page - --page)
          }
          return [1, '...'].concat(list)
        }
        return [
          1,
          '...',
          this.cur - 2,
          this.cur - 1,
          this.cur,
          this.cur + 1,
          this.cur + 2,
          '...',
          this.page
        ]
      }
    }
  },
  watch: {
    index(val) {
      this.cur = val
    }
  },
  methods: {
    goIndex(key) {
      if (key === '...') return
      this.cur = key
      this.emitParent()
    },
    goPrev() {
      this.cur = this.cur < 2 ? 1 : --this.cur
      this.emitParent()
    },
    goNext() {
      this.cur = this.cur === this.page ? this.page : ++this.cur
      this.emitParent()
    },
    emitParent() {
      this.$emit('change', this.cur)
    },
    getCurClass(key, index) {
      const isKey = key === '...'
      return {
        btn_num: !isKey,
        btn_more: isKey,
        cur: this.cur === key
      }
    }
  }
}
</script>

<style>
.xl-pag-disable {
  pointer-events: none;
}
</style>
